import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ActorCardCmp_ActorOrganization_Fragment = graphql(`
  fragment ActorCardCmp_ActorOrganization_Fragment on ActorOrganization {
    _id
    __typename
    categoryIds
    index
    isInternal
    typeId
    kind
    thirdPartyId
    useItsEdmDomain
    references {
      _id
      typeId
      value
    }
    representatives {
      _id
      personId
      person {
        _id
        lastName
        firstName
      }
      ...ActorCardCmp_Representative_Fragment
    }
  }
`);

export type ActorCardCmp_ActorOrganization = ResultOf<
  typeof ActorCardCmp_ActorOrganization_Fragment
>;
